var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgProfile = function SvgProfile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    fillRule: "evenodd",
    d: "M12 8.498a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7m-1.5 3.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#9A9A9A",
    fillRule: "evenodd",
    d: "M2 12.998c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10m10-8a8 8 0 0 0-5.607 13.706q.042-.09.086-.175c.503-1 1.532-1.531 2.56-1.531h5.923c1.027 0 2.056.53 2.56 1.531q.042.085.085.175A8 8 0 0 0 12 4.998M8.046 19.911q-.008.018-.013.036A7.96 7.96 0 0 0 12 20.998a7.96 7.96 0 0 0 3.967-1.051l-.013-.036a6 6 0 0 0-.22-.483c-.122-.245-.406-.43-.772-.43H9.038c-.366 0-.65.185-.773.43a6 6 0 0 0-.219.483",
    clipRule: "evenodd"
  })));
};
export default SvgProfile;